export const firebaseConfig = {
  apiKey: "AIzaSyAB9xZGHVSNH1TP5Kj29UQ0AsSmNF4A9dM",
  authDomain: "anime-73587.firebaseapp.com",
  projectId: "anime-73587",
  storageBucket: "anime-73587.appspot.com",
  messagingSenderId: "89246288914",
  appId: "1:89246288914:web:abfa005c77675ad60d1ccb",
  measurementId: "G-DMZNH0CHCR"
};